// @ts-check
import { isNil } from 'lodash-es';
import PubNub from 'pubnub';

import { useNonComponentHook } from '@/composables/useHookPair';
import { tre } from '@/plugins/bugsnag';

export const usePubnub = (key: string, userId: string) => {
  const pubnub = new PubNub({ subscribeKey: key, userId });

  const getUUID = () => {
    if (isNil(pubnub)) {
      const error = new Error('pubnub cannot be null');
      tre(error);
      throw error;
    }

    return pubnub.getUUID();
  };

  // #region post channels
  const [triggerMessageEvent, onMessageEvent] = useNonComponentHook();

  const postListeners = {
    message: (message: PubNub.MessageEvent) => {
      triggerMessageEvent({
        channel: message.channel,
        message: message.message,
        timetoken: message.timetoken,
      });
    },
  };

  const subscribePostChannels = (channels: string[]) => {
    if (isNil(pubnub)) {
      const error = new Error('pubnub cannot be null');
      tre(error);
      throw error;
    }

    pubnub.subscribe({
      channels,
    });

    pubnub.addListener(postListeners);
  };
  // #endregion post channels

  const destroy = () => {
    if (isNil(pubnub)) {
      tre(new Error('pubnub already destroy'));
      return;
    }
    pubnub.removeListener(postListeners);
    pubnub.unsubscribeAll();
    pubnub.stop();
  };

  return {
    type: 'pubnub',
    getUUID,
    subscribePostChannels,
    onMessageEvent,
    destroy,
  };
};
